import { render, staticRenderFns } from "./OpenInvoiceTypeDialog.vue?vue&type=template&id=4766336a&"
import script from "./OpenInvoiceTypeDialog.vue?vue&type=script&lang=js&"
export * from "./OpenInvoiceTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports